import { IconCurrencyDollar, IconExchange } from "@tabler/icons-react";
import React, { useState } from "react";
import { Form, Row, Col, InputGroup, Card } from "react-bootstrap";
import { useFormContext, useFieldArray, useWatch } from "react-hook-form";
import { truncateFormat } from "../../constant/_constant";

const ProductRmaDetails = () => {
  const {
    register,
    control,
    getValues,
    formState: { errors },
    watch,
  } = useFormContext();

  const [showField, setShowField] = useState(false);

  const { fields } = useFieldArray({
    control,
    name: "products", // Must match what you used in setValue
  });
  // const [selectedProductIndex, setSelectedProductIndex] = React.useState(null);

  const watchedProducts = useWatch({
    control,
    name: "products",
  });

  const totalRefundAmount = truncateFormat(
    watchedProducts?.reduce((sum, product) => {
      const refundQty = Number(product?.refund_qty || 0);
      const price = Number(product?.sku_price || 0);
      return sum + refundQty * price;
    }, 0),
    2
  );

  // const totalRefundAmount = watchedProducts
  //   ?.reduce((sum, product) => {
  //     const refundQty = Number(product?.refund_qty || 0);
  //     const price = Number(product?.sku_price || 0);
  //     return sum + refundQty * price;
  //   }, 0)
  //   .toFixed(2);

  // const totalCostData = watchedProducts?.reduce(
  //   (acc, product) => {
  //     const qty = Number(product?.qty || 0);
  //     const refundQty = Number(product?.refund_qty || 0);
  //     const price = Number(product?.sku_price || 0);

  //     acc.total += qty * price;
  //     acc.refund += refundQty * price;

  //     return acc;
  //   },
  //   { total: 0, refund: 0 }
  // );

  // const finalCost = (totalCostData?.total - totalCostData?.refund).toFixed(2);

  // const quantities = useWatch({
  //   control,
  //   name: "products",
  // })?.map((p) => Number(p.qty) || 0); // ensure numbers

  // const constAfterMargin = Number(getValues("totalCostAfterMargin") || 0);

  // // Calculate total cost dynamically
  // const dynamicTotalCost = quantities?.reduce(
  //   (sum, qty) => sum + constAfterMargin * qty,
  //   0
  // );
  // const costBeforeMargin = getValues("totalCostBeforeMargin");
  // const costAfterMargin = getValues("totalCostAfterMargin");
  return (
    <>
      {fields.map((item, index) => (
        <Card className="mb-3" key={item.id}>
          {/* <Card.Header className="card_header d-flex align-items-center gap-2">
            <IconExchange /> Product Details #{index + 1}
          </Card.Header> */}
          <Card.Body>
            <Row className="g-3 p-2 d-flex justify-content-between">
              <Col md={2}>
                <div className="fw-bold mb-3">VENDOR'S PARTNER</div>
                <Form.Group>
                  <InputGroup>
                    <Form.Control
                      {...register(`products[${index}].vendorName`)}
                      disabled
                    />
                  </InputGroup>
                </Form.Group>
              </Col>

              <Col md={2}>
                <div className="fw-bold mb-3">SKU ID</div>
                <Form.Group>
                  <InputGroup>
                    <Form.Control
                      {...register(`products[${index}].invoice_no`)}
                      disabled
                    />
                  </InputGroup>
                </Form.Group>
              </Col>

              <Col md={2}>
                <div className="fw-bold mb-3">SKU DESCRIPTION</div>
                <InputGroup>
                  <Form.Control
                    // as="textarea"
                    {...register(`products[${index}].prod_desc`)}
                    disabled
                  />
                </InputGroup>
              </Col>
              {/* <Col md={2}>
                <div className="fw-bold mb-3">SKU Description</div>
                <InputGroup>
                  <Form.Control
                    as="textarea"
                    {...register(`products[${index}].prod_desc`)}
                    disabled
                    rows={1} // minimum rows
                    style={{
                      // resize: "none", // optional: prevent manual resizing
                      overflow: "scroll", // hide scrollbar
                      // minHeight: "40px",
                    }}
                    onInput={(e) => {
                      e.target.style.height = "auto"; // reset height
                      e.target.style.height = e.target.scrollHeight + "px"; // set to scroll height
                    }}
                  />
                </InputGroup>
              </Col> */}

              <Col md={2}>
                <div className="fw-bold mb-3">QTY</div>
                <Form.Group>
                  <InputGroup>
                    <Form.Control
                      type="number"
                      {...register(`products[${index}].qty`)}
                      disabled
                    />
                  </InputGroup>
                  {errors?.products?.[index]?.qty && (
                    <span className="text-danger">
                      {errors.products[index].qty.message}
                    </span>
                  )}
                </Form.Group>
              </Col>

              <Col md={2}>
                <div className="fw-bold mb-3">CUSTOMER'S COST</div>
                <InputGroup>
                  <Form.Control
                    {...register(`products[${index}].sku_price`)}
                    disabled
                  />
                </InputGroup>
              </Col>

              <Col md={2}>
                <div className="fw-bold mb-3">RETURN QTY</div>
                <InputGroup>
                  <Form.Control
                    type="number"
                    {...register(`products[${index}].refund_qty`)}
                    placeholder="Enter Return Quantity"
                  />
                </InputGroup>
                {errors?.products?.[index]?.refund_qty && (
                  <span className="text-danger">
                    {errors.products[index].refund_qty.message}
                  </span>
                )}
              </Col>
              {showField && (
                <>
                  <Col md={2}>
                    <div className="fw-bold mb-3">AUTO ID</div>
                    <InputGroup>
                      <Form.Control
                        type="number"
                        {...register(`products[${index}].autoId`)}
                        placeholder="Enter Return Quantity"
                      />
                    </InputGroup>
                  </Col>
                </>
              )}
            </Row>
          </Card.Body>
        </Card>
      ))}
      {/* <div className="totle_costing mt-3">
        <h6>
          Total Cost Before Margin:
          <span>
            <IconCurrencyDollar />
            {costBeforeMargin}
          </span>
        </h6>
        <Form.Control
          {...register("totalCostBeforeMargin")}
          // value={totalCostBeforeMargin}
          readOnly
          type="hidden"
          placeholder="Total Cost Before Margin"
        />
      </div> */}
      <div className="totle_costing">
        <h6>
          Total Cost:
          <span>
            <IconCurrencyDollar />
            {totalRefundAmount}
            {/* {dynamicTotalCost.toFixed(2)} */}
          </span>
        </h6>
        <Form.Control
          {...register("totalCostAfterMargin")}
          // value={totalCostAfterMargin}
          readOnly
          type="hidden"
          placeholder="Total Cost After Margin"
        />
      </div>
    </>
  );
};

export default ProductRmaDetails;
